import type { Epic } from '../../index.js'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'
import { applicationSlice } from '../../Slice/Application/ApplicationSlice.js'
import { withLatestFrom } from 'rxjs/operators'
import { concat, EMPTY, filter, from, mergeMap, timer } from 'rxjs'
import { map } from 'rxjs/operators'
import { Actions } from '../../Slice/index.js'

export const HandleProjectLockChangedEpic: Epic = (action$, state$) => {
  const p = Actions[projectSlice.name]
  const a = Actions[applicationSlice.name]
  return action$.pipe(
    filter(p.wsProjectLockChanged.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {
      const { projectId, causer, locked } = action.payload
      const currentProjectId = state.project.currentProject?.id
      const currentUserId: string | undefined = state.authentication?.user?.id

      // 1) Only react if this is about the currently viewed project
      if (!currentProjectId || currentProjectId !== projectId) {
        return EMPTY
      }

      // 2) Ignore if we are the causer (self-originated change)
      if (causer?.type === 'user' && causer.id && currentUserId && causer.id === currentUserId) {
        // ...unless a failed request left us showing that lock; the release precedes the request's commit.
        if (!locked && state.project.currentProject?.lock) {
          return concat(
            from([p.getProjectRequest({ projectId }), p.loadProjectOrdersRequest({ projectId })]),
            timer(SELF_UNLOCK_REFETCH_DELAY_MS).pipe(map(() => p.getProjectSamplesRequest({ projectId })))
          )
        }
        return EMPTY
      }

      if (locked) {
        return from([a.addBlockingRequest(ProjectLockedBlocker(projectId)), p.getProjectRequest({ projectId })])
      } else {
        return from([p.getProjectRequest({ projectId }), a.removeBlockingRequest(ProjectLockedBlockerId(projectId))])
      }
    })
  )
}

export const SELF_UNLOCK_REFETCH_DELAY_MS = 3000

export const ProjectLockedBlockerId = (projectId: string) => `project-lock-${projectId}`

export const ProjectLockedBlocker = (projectId: string) => {
  return {
    id: ProjectLockedBlockerId(projectId),
    title: 'Project data is refreshing',
    message: 'Another user has caused the project to be recomputed, please wait'
  }
}
